module.exports = __webpack_public_path__ + "img/5.d550b083.jpg";